<div class="grid gap-4">
  @if (!hideLagerplaetze()) { @if (data()?.itemStorage && (data()?.itemStorage?.length ||
  0) > 0) {
  <soft-ds-card density="none" #lagerplaetze>
    <cdk-accordion>
      <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        [expanded]="lagerplaetzeExpanded()"
        [attr.aria-expanded]="accordionItem.expanded"
        class="flex flex-col"
      >
        <div
          class="flex justify-between items-center cursor-pointer p-4"
          role="button"
          tabindex="0"
          (click)="accordionItem.toggle()"
          (keydown.enter)="accordionItem.toggle()"
          (keydown.space)="$event.preventDefault(); accordionItem.toggle()"
        >
          <div class="flex items-center gap-2">
            <h6
              class="font-semibold text-light text-sm uppercase leading-wide tracking-wide"
            >
              {{ '#ARTIKELINFO.PAGES.DETAIL.STOCK_LOCATIONS.TITLE' | translate }}
            </h6>
            <soft-ds-badge size="md" variant="outline">
              {{ data()?.itemStorage?.length }}
            </soft-ds-badge>
          </div>
          <div
            class="text-light bg-surface rounded-full p-3 m-1 cursor-pointer hover:bg-hover"
          >
            @if (!accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-down" />
            } @if (accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-up" />
            }
          </div>
        </div>

        <div
          class="px-4 pb-4"
          [style.display]="accordionItem.expanded ? 'block' : 'none'"
        >
          <div class="flex flex-col gap-3">
            @for (storage of $safeNavigationMigration(data()?.itemStorage); track storage) {
            <soft-ds-card class="flex flex-col gap-3">
              <div class="flex items-center gap-3">
                <div
                  class="border border-primary text-primary rounded-lg p-3 shrink-0 bg-primary-50"
                >
                  <soft-icon name="fa-regular fa-location-dot" />
                </div>
                <div class="flex flex-col gap-1 flex-1">
                  <div class="flex gap-1">
                    <span class="font-semibold text-sm">
                      {{ storage.title || storage.name }}
                    </span>
                    @if(storage.kzlagerplatz === 'H'){
                    <soft-ds-badge variant="success" class="self-start">
                      {{ '#ARTIKELINFO.PAGES.DETAIL.STOCK.MAIN' | translate }}
                    </soft-ds-badge>
                    }
                  </div>
                  <span class="text-sm">
                    {{ storage.stock?.title || storage.stock?.name }}
                  </span>
                </div>
              </div>
            </soft-ds-card>
            }
          </div>
        </div>
      </cdk-accordion-item>
    </cdk-accordion>
  </soft-ds-card>
  } }
  <!-- TODO: WHY COMMENTED OUT ? @edith -->
  <!-- div class="flex flex-col mt-5" *ngIf="details?.itemStorage && (details?.itemStorage?.length || 0) > 0">
  <h6 class="font-semibold text-light text-sm mb-1 uppercase leading-wide tracking-wide">{{ '#ARTIKELINFO.PAGES.DETAIL.STOCK_LOCATIONS.TITLE' | translate }}</h6>
  <div class="full-width flex flex-col bg-white"
    *ngFor="let stockStorageData of details.itemStorage | groupByStock; let first = first"
    [ngClass]="first ? 'border-t border-t-solid border-t-separator' : ''">
    <div class="flex px-4 py-2 items-center w-full border-b border-b-solid border-b-separator bg-gray-100">
      <div class="w-full text-[0.825rem] font-semibold">{{ stockStorageData.stock?.title || stockStorageData.stock?.name }}</div>
    </div>
    <div *ngFor="let storage of stockStorageData?.storages"
      class="flex px-4 py-3 items-center justify-between w-full text-sm border-b border-b-solid border-b-separator"
      [class.!bg-green-50]="storage?.kzlagerplatz === 'H'">
      <div>{{ storage.title }} {{ storage?.name }}</div>
    </div>
  </div>
  </div>-->
  @if (!hideEinheiten()) { @if (data()?.itemStorage && (data()?.itemStorage?.length || 0)
  > 0) {
  <soft-ds-card density="none" #einheiten>
    <cdk-accordion>
      @if (data()?.itemUnitData; as units) {
      <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        [expanded]="einheitenExpanded()"
        [attr.aria-expanded]="accordionItem.expanded"
        class="flex flex-col"
      >
        <div
          class="flex justify-between items-center cursor-pointer p-4"
          role="button"
          tabindex="0"
          (click)="accordionItem.toggle()"
          (keydown.enter)="accordionItem.toggle()"
          (keydown.space)="$event.preventDefault(); accordionItem.toggle()"
        >
          <div class="flex items-center gap-2">
            <h6
              class="font-semibold text-light text-sm uppercase leading-wide tracking-wide"
            >
              {{ '#ARTIKELINFO.PAGES.DETAIL.UNITS.TITLE' | translate }}
            </h6>
            <soft-ds-badge size="md" variant="outline">{{ units.length }}</soft-ds-badge>
          </div>
          <div
            class="text-light bg-surface rounded-full p-3 m-1 cursor-pointer hover:bg-hover"
          >
            @if (!accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-down" />
            } @if (accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-up" />
            }
          </div>
        </div>

        <div
          class="px-4 pb-4"
          [style.display]="accordionItem.expanded ? 'block' : 'none'"
        >
          <div class="flex flex-col gap-3">
            @for (unit of units ?? [] | sort: 'factor' : 'ASC'; track unit) {
            <soft-ds-card class="flex flex-col gap-3">
              <div class="flex items-center gap-3">
                <soft-ds-badge variant="primary" size="lg">
                  {{ unit?.itemUnit?.name }}
                </soft-ds-badge>
                <span class="font-semibold text-sm flex-1 min-w-0">
                  {{ unit?.itemUnit?.title }}
                </span>
              </div>
              <div class="grid grid-cols-2 gap-2">
                <div
                  class="flex flex-col gap-1 bg-surface-secondary rounded-lg px-3 py-2"
                >
                  <span class="text-xs font-semibold text-light uppercase tracking-wide">
                    {{ '#ARTIKELINFO.PAGES.DETAIL.UNITS.FACTOR' | translate }}
                  </span>
                  <span class="font-bold text-sm">
                    {{ $safeNavigationMigration(unit?.factor) | number: '1.2-2' }}
                  </span>
                </div>
                <div
                  class="flex flex-col gap-1 bg-surface-secondary rounded-lg px-3 py-2"
                >
                  <span class="text-xs font-semibold text-light uppercase tracking-wide">
                    {{ '#ARTIKELINFO.PAGES.DETAIL.UNITS.WEIGHT' | translate }}
                  </span>
                  <span class="font-bold text-sm">
                    {{ $safeNavigationMigration(unit?.weight) | number: '1.2-2' }} kg
                  </span>
                </div>
              </div>
            </soft-ds-card>
            }
          </div>
        </div>
      </cdk-accordion-item>
      }
    </cdk-accordion>
  </soft-ds-card>
  } } @if (!hideLieferanten()) { @if (data()?.itemSupplier; as suppliers) {
  <soft-ds-card density="none" #suppliersCard>
    <cdk-accordion>
      <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        [expanded]="lieferantenExpanded()"
        [attr.aria-expanded]="accordionItem.expanded"
        class="flex flex-col"
      >
        <div
          class="flex justify-between items-center cursor-pointer p-4"
          role="button"
          tabindex="0"
          (click)="accordionItem.toggle()"
          (keydown.enter)="accordionItem.toggle()"
          (keydown.space)="$event.preventDefault(); accordionItem.toggle()"
        >
          <div class="flex items-center gap-2">
            <h6
              class="font-semibold text-light text-sm uppercase leading-wide tracking-wide"
            >
              {{ '#ARTIKELINFO.PAGES.DETAIL.SUPPLIERS.TITLE' | translate }}
            </h6>
            <soft-ds-badge size="md" variant="outline">
              {{ suppliers.length }}
            </soft-ds-badge>
          </div>
          <div
            class="text-light bg-surface rounded-full p-3 m-1 cursor-pointer hover:bg-hover"
          >
            @if (!accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-down" />
            } @if (accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-up" />
            }
          </div>
        </div>

        <div
          class="px-4 pb-4"
          [style.display]="accordionItem.expanded ? 'block' : 'none'"
        >
          <div class="flex flex-col gap-1">
            @for (supplier of suppliers; track supplier) {
            <soft-ds-card>
              <div class="flex flex-col gap-1">
                <div class="flex gap-1">
                  <span class="font-semibold text-sm">{{ supplier.supplier?.name }}</span>
                  @if(supplier.supplier.kzliefgelistet === 'H') {
                  <soft-ds-badge variant="success" class="self-start">
                    {{ '#ARTIKELINFO.PAGES.DETAIL.SUPPLIERS.MAIN' | translate }}
                  </soft-ds-badge>
                  }
                </div>
                <span class="text-light text-xs md:text-sm">
                  {{ '#ARTIKELINFO.PAGES.DETAIL.SUPPLIERS.SUPPLIER_NUMBER' | translate }}
                  {{ supplier.supplier?.number }} @if (supplier.foreignNumber) { · {{
                  '#ARTIKELINFO.PAGES.DETAIL.SUPPLIERS.SUPPLIER_ITEM_NUMBER' | translate
                  }} {{ supplier.foreignNumber }} }
                </span>
                <div class="flex items-center gap-2 text-light text-xs md:text-sm">
                  <soft-icon name="fa-regular fa-box" />
                  <span>
                    {{ '#ARTIKELINFO.PAGES.DETAIL.SUPPLIERS.MIN_ORDER_AMOUNT' | translate
                    }}:
                  </span>
                  <span class="font-bold">
                    @if(!supplier.minAmount){ {{
                    '#ARTIKELINFO.PAGES.DETAIL.SUPPLIERS.NO_MIN' | translate }} }@else{ {{
                    supplier.minAmount | number: '1.2-2' }} {{ supplier?.itemUnit?.name ||
                    supplier?.itemUnit?.title }} }
                  </span>
                </div>
              </div>
            </soft-ds-card>
            }
          </div>
        </div>
      </cdk-accordion-item>
    </cdk-accordion>
  </soft-ds-card>
  } }
</div>
